import { Dropdown } from "react-bootstrap";
import EllipsisVerticalToggle from "./EllipsisVerticalToggle";
import { useTranslation } from "react-i18next";
import { faPen, faTrash, faEye } from "@fortawesome/free-solid-svg-icons";
import IconBubble from "./IconBubble";

const CompleteDropdown = ({
  deleteAction = null,
  deleteTitle = null,
  editAction = null,
  editTitle = null,
  viewAction = null,
  viewTitle = null,
  children,
  addFront = false,
}) => {
  const { t } = useTranslation();

  const hasNonDestructive = viewAction || editAction || (addFront && children);
  const showDividerBeforeDelete = deleteAction && hasNonDestructive;

  return (
    <Dropdown style={{ display: "inline-block" }}>
      <EllipsisVerticalToggle />
      <Dropdown.Menu popperConfig={{ strategy: "fixed" }} renderOnMount>
        {addFront && children}
        {viewAction && (
          <Dropdown.Item onClick={viewAction} className="d-flex align-items-center">
            <IconBubble icon={faEye} bg="rgba(95,208,243,0.15)" color="#0e9bbf" />
            {viewTitle ?? t("Backend.Dropdown.View")}
          </Dropdown.Item>
        )}
        {editAction && (
          <Dropdown.Item onClick={editAction} className="d-flex align-items-center">
            <IconBubble icon={faPen} bg="rgba(3,142,220,0.12)" color="#038edc" />
            {editTitle ?? t("Backend.Dropdown.Edit")}
          </Dropdown.Item>
        )}
        {!addFront && children}
        {showDividerBeforeDelete && <div className="dropdown-divider" />}
        {deleteAction && (
          <Dropdown.Item onClick={deleteAction} className="d-flex align-items-center">
            <IconBubble icon={faTrash} bg="rgba(243,78,78,0.12)" color="#f34e4e" />
            <span style={{ color: "#f34e4e" }}>{deleteTitle ?? t("Backend.Dropdown.Delete")}</span>
          </Dropdown.Item>
        )}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default CompleteDropdown;
